<template>
  <div class="home-pending">
    <template v-if="rows.length > 0">
      <div
        v-for="row in rows"
        :key="row.key"
        class="home-pending__row"
        @click="$router.push(row.route)"
      >
        <i class="home-pending__icon" :class="[row.icon, `home-pending__icon--${row.level}`]"></i>
        <span class="home-pending__info">
          <span class="home-pending__count">{{ row.count }}</span>
          <span class="home-pending__label">{{ $t(row.label) }}</span>
        </span>
        <i class="el-icon-arrow-right home-pending__arrow"></i>
      </div>
    </template>
    <div v-else class="home-pending__clear">
      <i class="el-icon-circle-check"></i>
      <span>{{ $t("nenhuma-pendencia") }}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "HomePendingList",
  props: {
    period: {
      type: Object,
      default: () => ({}),
    },
    pending: {
      type: Object,
      default: () => ({ expiredLabels: 0, deliveryFailures: 0, devolutions: 0 }),
    },
  },
  computed: {
    rows() {
      const startedAt = this.period.startedAt || moment().subtract(30, "days").format("YYYY-MM-DD");
      const finishedAt = this.period.finishedAt || moment().format("YYYY-MM-DD");
      const post = (statuses) => ({
        name: "post",
        query: { statuses, byCreationDate: "1", startedAt, finishedAt },
      });
      const prepost = (statuses) => ({
        name: "pre.post",
        query: { statuses, startedAt, finishedAt },
      });
      const items = [
        { key: "expired", count: this.pending.expiredLabels, label: "etiquetas-expiradas", level: "danger", icon: "el-icon-alarm-clock", route: prepost(["18"]) },
        { key: "failures", count: this.pending.deliveryFailures, label: "falhas-entrega-averiguar", level: "danger", icon: "el-icon-warning-outline", route: post(["12", "14"]) },
        { key: "devolutions", count: this.pending.devolutions, label: "devolucoes-andamento", level: "warning", icon: "el-icon-refresh-left", route: post(["15"]) },
      ];
      return items.filter((item) => item.count > 0);
    },
  },
};
</script>

<style>
.home-pending__row {
  display: flex;
  align-items: center;
  padding: 10px 4px;
  border-bottom: 1px solid var(--me-border-lighter);
  cursor: pointer;
  transition: background-color 0.2s ease, padding-left 0.2s ease;
}

.home-pending__row:last-child {
  border-bottom: none;
}

.home-pending__row:hover {
  background-color: var(--me-fill);
  padding-left: 10px;
}

.home-pending__icon {
  font-size: 18px;
  margin-right: 10px;
}

.home-pending__icon--warning {
  color: var(--me-warning);
}

.home-pending__icon--danger {
  color: var(--me-danger);
}

.home-pending__info {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.home-pending__count {
  font-size: 16px;
  font-weight: 700;
  color: var(--me-text-primary);
  margin-right: 8px;
  font-variant-numeric: tabular-nums;
}

.home-pending__label {
  font-size: 13px;
  color: var(--me-text-regular);
}

.home-pending__arrow {
  color: var(--me-text-placeholder);
  transition: transform 0.2s ease, color 0.2s ease;
}

.home-pending__row:hover .home-pending__arrow {
  transform: translateX(3px);
  color: var(--me-primary);
}

.home-pending__clear {
  display: flex;
  align-items: center;
  padding: 14px 4px;
  color: var(--me-text-regular);
  font-size: 13px;
}

.home-pending__clear i {
  color: var(--me-success);
  font-size: 18px;
  margin-right: 8px;
}
</style>
